import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    DeleteEventAttendeesMutation,
    DeleteEventAttendeesMutationVariables,
} from './Attendee.mutations.generated'

export const DELETE_ATTENDEE: TypedDocumentNode<
    DeleteEventAttendeesMutation,
    DeleteEventAttendeesMutationVariables
> = gql`
    mutation DeleteEventAttendees($input: deleteEventAttendeesInput!) {
        deleteEventAttendees(input: $input) {
            entity {
                guid
            }
        }
    }
`
